module.exports = __webpack_public_path__ + "static/media/li.49fbee58.jpeg";